import styled from "styled-components";

export const StationWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 32px;
  height: 100%;
  overflow: auto;
`;
